export default "__VITE_ASSET__BoV5dV4B__"